import { HardwareVersionPagination } from '../model/hardware_version_pagination';
import { FetchHardwareVersionRepository } from './../../data/repository/fetch_hardware_version_repository';
import { Pagination } from "@/core/domain/model/pagination";
import { DataOptions } from "vuetify";
import { en } from '../model/hardware_version';

export interface FetchHardwareVersionUseCase {
    (pagination: DataOptions, search: string): Promise<HardwareVersionPagination>
}

const fetchHardwareVersionUseCase = (repository: FetchHardwareVersionRepository): FetchHardwareVersionUseCase => async (pagination: DataOptions, search: string) => {
    try {
        const payload: Pagination = {
            sort: pagination.sortBy.map((s: string) => en[s]).join(','),
            descending: pagination.sortDesc.join(','),
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            search: search
        }
        return await repository(payload);
    } catch (error) {
        throw error
    }
}

export default fetchHardwareVersionUseCase;